// src/components/BoardStatusSelector.jsx
import React, { useState } from 'react';

const BOARD_STATUSES = [
  { value: 'new', label: 'New', color: '#6c757d', icon: '🆕' },
  { value: 'in_progress', label: 'In Progress', color: '#007bff', icon: '🔄' },
  { value: 'done', label: 'Done', color: '#28a745', icon: '✅' }
];

function BoardStatusSelector({ currentStatus, onStatusChange, disabled = false }) {
  const [isOpen, setIsOpen] = useState(false);

  const currentStatusInfo = BOARD_STATUSES.find(s => s.value === currentStatus) || BOARD_STATUSES[0];

  const handleStatusSelect = (status) => {
    onStatusChange(status.value);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '4px 8px',
          background: currentStatusInfo.color,
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: '500',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.target.style.opacity = '0.8';
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.target.style.opacity = '1';
          }
        }}
      >
        <span>{currentStatusInfo.icon}</span>
        <span>{currentStatusInfo.label}</span>
        <span style={{ fontSize: '10px', opacity: 0.8 }}>▼</span>
      </button>

      {isOpen && (
        <>
          {/* Click-outside backdrop */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999
            }}
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown menu */}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              background: 'white',
              border: '1px solid #ddd',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 1000,
              minWidth: '140px',
              overflow: 'hidden',
              marginTop: '2px'
            }}
          >
            {BOARD_STATUSES.map(status => (
              <button
                key={status.value}
                onClick={() => handleStatusSelect(status)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                  padding: '8px 12px',
                  background: currentStatus === status.value ? '#f8f9fa' : 'white',
                  border: 'none',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background-color 0.2s ease',
                  borderBottom: '1px solid #f0f0f0'
                }}
                onMouseEnter={(e) => {
                  if (currentStatus !== status.value) {
                    e.target.style.backgroundColor = '#f8f9fa';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentStatus !== status.value) {
                    e.target.style.backgroundColor = 'white';
                  }
                }}
              >
                <span style={{ fontSize: '14px' }}>{status.icon}</span>
                <span style={{ flex: 1 }}>{status.label}</span>
                {currentStatus === status.value && (
                  <span style={{ color: status.color, fontSize: '12px' }}>●</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BoardStatusSelector;